<template>
    <div class="w100" style="background-repeat : no-repeat;background-size: 100%" :style="{ 'background-image': `url(${baseUrl}images/adviceBack.png)` }">
        <div class="ad-content"  v-loading="loading">
            <div  class="area card-shadow">
                <div class="area-title">
                    投诉建议
                </div>
                <div class="area-remark">
                    尊敬的用户：
                    <br/>
                    <br/>
                    您好！感谢您给我们提出宝贵的建议，我们会进行严格保密。您的个人信息绝不会向外公开，请根据您的实际情况或内心真实想法如实填写。
                    如需查看回复情况，您可以在用户中心进行查看。
                </div>
                <el-form label-width="120px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline cl-f" :validate-on-rule-change=false>
                        <el-form-item label="建议标题" prop="title" >
                            <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="建议类型" prop="type" >
                            <el-radio-group v-model="form.type">
                                <el-radio :label="0">网站建议</el-radio>
                                <el-radio :label="1">部门建议</el-radio>
                                <el-radio :label="2">我要纠错</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="部门" v-show="form.type== 1" prop="deptId" >
                            <TreeSelect size="small"
                                        :data="departmentData"
                                        clearable
                                        expandAll
                                        ref="deptSingle"
                                        :obj="mapKey"
                                        checkStrictly
                                        @getValue="setDeptSingleMenu">
                            </TreeSelect>
                        </el-form-item>
                        <el-form-item label="建议人姓名" prop="name" >
                        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="建议人手机号" prop="mobile" >
                            <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="建议人联系地址" prop="address">
                            <el-input v-model="form.address" placeholder="请输入联系地址"></el-input>
                        </el-form-item>
                        <el-form-item label="附件上传" prop="iconId" >
                            <el-upload

                                    class="upload-demo"
                                    action="#"
                                    :file-list="filelist"
                                    :before-remove="beforeRemove"
                                    :before-upload="beforeUpload"
                            >
                                <el-button  v-if="filelist.length==0" slot="trigger">
                                    <i class="el-icon-upload"></i>
                                </el-button>
                            </el-upload>
                            <div class="el-upload-tip">
                                支持DOC、XLS、XLSX、JPG、RAR、ZIP、TXT、PNG格式
                            </div>
                        </el-form-item>
                        <el-form-item label="建议内容" prop="content" >
                            <el-input v-model="form.content" type="textarea" placeholder="请输入要建议的内容"></el-input>
                        </el-form-item>

                        <el-form-item label="是否公开" prop="privateFlag" >
                            <el-radio-group v-model="form.privateFlag">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>

                </el-form>
                <div style="text-align:center">
                    <el-button @click="submitForm('ruleForm')" :disabled="loading" type="primary">提 交</el-button>
                    <el-button @click="$router.push({path:'/office'})">取 消</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { adviceAdd} from '@/api/managementCenter/advices';
    import TreeSelect from "@/components/TreeSelect.vue";
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    import { sysFileUpload,sysFileDelete} from '@/api/managementCenter/otherApi';
    import { validatePhone} from '@/util/validate';
    export default {
        name: "addAdvice",
        components: {TreeSelect},
        props: [],
        data() {
            const vali_phone=(rule, value, callback)=>{
                if (value) {
                    if(validatePhone(value)){
                        callback();
                    }else{
                        callback(new Error('请输入正确的手机号码'));
                    }
                }else{
                    callback(new Error('请输入手机号码'));
                }
            };
            const vali_dept=(rule, value, callback)=>{
                if(this.form.type == 1){
                    if(value){
                        callback();
                    }else{
                        callback(new Error('请选择建议的部门'));
                    }
                }else{
                    callback();
                }
            };
            return {
                baseUrl: process.env.BASE_URL,
                loading:false,
                departmentData:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                filelist:[],
                form:{
                    address: "",
                    attachId: "",
                    content: "",
                    deptId: "",
                    mobile: "",
                    name: "",
                    privateFlag: "",
                    title: "",
                    type: ""
                },
                rules: {
                    title: [
                        { required: true, message: "请输入建议标题", trigger: "change" }
                    ],
                    type: [
                        { required: true, message: "请选择建议类型", trigger: "change" }
                    ],
                    deptId: [
                        { validator:vali_dept, required: true, trigger: 'change'  }
                    ],
                    name: [
                        { required: true, message: "请输入姓名", trigger: "change" }
                    ],
                    mobile: [
                        { validator:vali_phone, required: true, trigger: 'change' }
                    ],
                    address: [
                        { required: true, message: "请输入联系地址", trigger: "change" }
                    ],
                    content: [
                        { required: true, message: "请输入内容", trigger: "change" },
                        { max: 200, message: '最多200个字符', trigger: 'change' }
                    ],
                    privateFlag: [
                        { required: true, message: "请选择是否公开", trigger: "change" }
                    ]
                }

            };
        },
        computed: {},
        created() {},
        mounted() {
            this.getDeptTreeData();
        },
        methods: {
           adviceAddFn(){
                this.loading = true;

               adviceAdd(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "提交成功!" );
                        this.$router.push({path:'/office'})
                        // this.form={
                        //     address: "",
                        //         attachId: "",
                        //         content: "",
                        //         deptId: "",
                        //         mobile: "",
                        //         name: "",
                        //         privateFlag: "",
                        //         title: "",
                        //         type: ""
                        // };

                    }else{
                        this.$message.warning(  data.msg||"提交失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        this.departmentData = data.data
                    }
                }).catch(err=>{

                })

            },
            setDeptSingleMenu(key,data){
                this.form.deptId=data.id
            },
            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.adviceAddFn()
                    } else {
                        return false;
                    }
                });
            },
            beforeRemove(file) {
                if(!file.id){
                    return;
                }
                this.deleteFile(file.id,()=>{
                         this.filelist =this.filelist.filter(i=>{
                             return file.id!=i.id
                         })
                })
            },
            deleteFile(id,callback){
                sysFileDelete(id).then(({data}) => {
                    if(data.code == 0){
                        callback&&callback()
                        this.$message.success(  "删除成功!" );
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(err=>{
                    this.$message.error( "删除异常!" );
                })
            },
            // 上传文件之前的方法
            beforeUpload(file){

                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                    return isLt2M
                }
                let fd = new FormData();
                fd.append('fromTarget',0)
                fd.append('file',file);
                //上传到后台
                this.loading=true
                sysFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$message.success(  "上传文件成功!" );
                        this.filelist.push(
                            {
                                ...data.data,
                                name:data.data.fileName

                            }
                        )
                    }else{
                        this.$message.warning( data.msg|| "上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });
            },

        },
        destroyed() {

        },
        watch: {
            filelist(arr){
                if(arr.length){
                    this.form.attachId=arr[0].id
                }else{
                    this.form.attachId=""
                }
            }
        },
        filters: {},
    };
</script>

<style scoped lang="less" >
    .ad-content{
        width: 800px;
        padding-top: 95px;
        margin: 0 auto;
    }
    .area{

        background: #FFFFFF;
        width: 700px;
        margin: 0 auto;
        padding: 40px 40px;
        border-radius: 5px;
        overflow: hidden;
        &-title{
            font-size: 18px;
            padding-bottom: 40px;
            font-weight: bold;
            text-align: center;
            font-family: Microsoft YaHei;
        }
        &-remark{
            padding:10px 10px 30px 50px;
            line-height: 24px;
        }
    }

</style>
